import { render } from "./CreateReminderModal.vue?vue&type=template&id=f26cfcb6"
import script from "./CreateReminderModal.vue?vue&type=script&lang=js"
export * from "./CreateReminderModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__